import React ,{ useState ,useRef,useEffect} from "react";
import { BCMSDate } from "bcms-react";
import Month  from "../Month";
import PickerHeader from "../PickerHeader";
import PickerFooter from "../PickerFooter";

export default function SingleCalendar(props) {
    const [viewDate, setViewDate] = useState( BCMSDate.init(props.setDate).date);
    const [hoverDate, setHover] = useState( BCMSDate.init(props.setDate));
    const ref = useRef();
    let enablePast =  props.enablePast ?? false;
  let enableFuture = props.enableFuture ?? true;
  let disableDay = props.disableDay;
    const changeHover=function(date){
        if(date.isEqual(hoverDate) === false){          
            setHover(date);
        }
    }
    let month1 = BCMSDate.init(viewDate);
    let month2 = BCMSDate.init(viewDate).offset([0,1,0])  
    return(      
        <div className="date-picker">
            <div className="row"><PickerHeader month1={month1} enablePast={enablePast} enableFuture={enableFuture} disableDay={disableDay} month2={month2} setViewDate={setViewDate} disabled={props.disabled} /></div> 
            <div className='calendar-wrapper'>
                <Month viewDate={month1} enablePast={enablePast} enableFuture={enableFuture} disableDay={disableDay} setDate={props.setDate} setHover={changeHover} onChange={props.onChange} controllers={props.controllers} inputDate={props.inputDate}/>                
            </div>
            <PickerFooter hoverDate={hoverDate}/>
        </div>                
    )
} 